// HTML select provides only .value, therefore there is a compoundID with a prefix of dq: for fields with dq

export const toViewName = (entityField, dq2Value) => {
	if (entityField) return entityField;
	else if (dq2Value) return "dq:" + dq2Value;
	else return '';
};
export const fromViewName = (mergedFieldName) => {
	let field, dq2Value;
	if (_.startsWith(mergedFieldName, 'dq:')) {
		field = null;
		dq2Value = mergedFieldName.substr(3);
	} else {
		field = mergedFieldName;
		dq2Value = null;
	}
	return {field, dq2Value};
};